import {IPaymentGate, IPaymentMethod} from '@dev-fast/types';

export const filterMethod = (methods: IPaymentMethod[]): IPaymentMethod[] => {
  return methods.map((method: IPaymentMethod) => ({ ...method, gates: method.gates.filter((gate: IPaymentGate) => gate.is_enabled) }));
};
